// Render text component with special behavior when hovered on and clicked
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

interface ExternalLinkTextProps {
  text: string;
  onClick: () => void;
  title?: string;
  textClassName?: string;
  iconClassName?: string;
  absoluteIcon?: boolean;
  topClassName?: string;
  underlineOnHover?: boolean;
}

export default function ExternalLinkText({
  text,
  onClick: onClickHandler,
  title,
  textClassName,
  iconClassName,
  absoluteIcon,
  topClassName,
  underlineOnHover,
}: ExternalLinkTextProps) {
  return (
    <div
      className={clsx(
        'clickable group relative line-clamp-2',
        underlineOnHover ? 'hover:underline' : 'underline',
        textClassName
      )}
      title={title}
      onClick={onClickHandler}
    >
      {text}{' '}
      <ArrowTopRightOnSquareIcon
        className={clsx(
          'invisible inline size-4 group-hover:visible',
          absoluteIcon && 'bg-base-100 absolute right-0',
          absoluteIcon && (topClassName || 'top-[5px]'),
          iconClassName
        )}
      />
    </div>
  );
}
